import { useQuery, UseQueryResult } from 'react-query'
import {
  fetchWallet,
  fetchWalletActivity,
  fetchWalletPerformanceHistory,
  WalletSummary,
  WalletActivity,
  PerformanceEntry
} from 'api/wallet'

export function useWallet(): UseQueryResult<WalletSummary> {
  return useQuery(['wallet'], fetchWallet, { staleTime: 0 })
}

export function useWalletActivity(
  page: number,
  pageSize: number
): UseQueryResult<WalletActivity> {
  return useQuery(
    ['wallet-activity', page, pageSize],
    () => fetchWalletActivity(page, pageSize),
    { staleTime: 0 }
  )
}

export function useWalletPerformanceHistory(
  productIds?: number[],
  vaultIds?: number[],
  timeframe?: string
): UseQueryResult<PerformanceEntry[]> {
  return useQuery(
    ['wallet-performance', productIds, vaultIds, timeframe],
    () => fetchWalletPerformanceHistory(productIds, vaultIds, timeframe),
    { staleTime: 300_000 }
  )
}
